import { render } from "./ReauthorisePluginDialog.vue?vue&type=template&id=7d56a95a"
import script from "./ReauthorisePluginDialog.vue?vue&type=script&lang=js"
export * from "./ReauthorisePluginDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QBtn});
